import React from 'react';
import { Link } from 'app/shared/link/link';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { breakPoints } from 'app/constants';

export const Logo = ({ className, setting }) => {
    const isMobile = !useMediaQuery({
        query: breakPoints.xsMobile,
    });
    return (
        <Link to={'/'} className={className}>
            <img
                alt=""
                src={
                    isMobile
                        ? setting.content.navbar.logoMobile
                        : setting.content.navbar.logo
                }
            />
        </Link>
    );
};

function mapStateToProps(state) {
    return {
        setting: state.appState.setting,
    };
}

export const LogoLink = connect(mapStateToProps)(Logo);
